<footer class="ax-bg-surface ax-py-6 ax-border-t">
  <section class="ax-container ax-m-auto sm:ax-my-10">
    <div class="ax-grid ax-grid-cols-1 ax-gap-8 md:ax-grid-cols-2 xl:ax-grid-cols-3 xl:ax-gap-4">
      <div class="ax-flex ax-flex-col ax-gap-3">
        <!-- دسترسی سریع -->
        <p class="ax-font-bold">{{ 'footer.quickAccess' | translate | async }}</p>
        <div class="ax-grid ax-grid-cols-2 ax-gap-8 ax-text-sm">
          <div class="ax-flex ax-flex-col ax-gap-4">
            <!-- صفحه اصلی -->
            <a (click)="goToUrl()">{{ 'footer.home' | translate | async }}</a>
            <!-- سوالات متداول -->
            <!-- <a #faq [routerLink]="['faq']">{{'footer.frequentlyAskedQuestions' | translate | async}}</a> -->
            <!-- قوانین و مقررات -->
            <a #policy [routerLink]="['policy']" *ngIf="!settingData.baseUrl">{{ 'footer.termsAndConditions' | translate
              | async }}</a>
            <!-- ثبت درخواست و شکایت -->
            <!-- <a #contacts [routerLink]="['contact']">{{'footer.submitRequestAndComplaint' | translate | async}}</a> -->
          </div>
          <div class="ax-flex ax-flex-col ax-gap-4 ax-text-sm" *ngIf="!settingData.baseUrl">
            <!-- درباره ما -->
            <a #aboutUs [routerLink]="['about-us']">{{ 'footer.aboutUs' | translate | async }}</a>
            <!-- تماس با ما -->
            <a #contact [routerLink]="['contact']">{{ 'footer.contactUs' | translate | async }}</a>
          </div>
        </div>
      </div>
      <div class="ax-flex ax-flex-col ax-gap-3">
        <!-- تماس با ما -->
        <p class="ax-font-bold">{{ 'footer.contactUs' | translate | async }}</p>
        <div class="ax-flex ax-flex-col ax-gap-4 ax-text-sm">
          <!-- وایت لیبل -->
          <p>{{ settingData.address }}</p>
          <!-- تلفن پشتیبانی -->
          <span class="ax-flex">
            <p>{{ 'footer.supportNumber' | translate | async }}:</p>
            <p>
              {{ settingData.supportTel }}
            </p>
          </span>
          <!-- ایمیل -->
          <p>
            {{ 'footer.email' | translate | async }}
            <a href="mailto:{{ settingData.email }}" rel="noopener noreferrer">{{ settingData.email }}</a>
          </p>
        </div>
      </div>
      <div class="ax-flex ax-flex-col ax-justify-start ax-gap-3">

        <!-- وایت لیبل -->
        <img src="{{ env }}/{{ settingData.logo }}" [alt]="settingData.pageTitle"
          class="ax-h-12 ax-w-fit ax-object-contain" />
        <p class="ax-text-justify ax-text-sm">
          {{ settingData.footerDescription }}
        </p>
        <div class="ax-flex ax-flex-wrap ax-gap-4">
          <div class="ax-flex ax-h-20 ax-w-20 ax-items-start ax-p-2 ax-card" *ngFor="let nemad of nemadList">
            <a [href]="nemad.link" class="ax-h-full ax-w-full">
              <img [src]="nemad.eNemadImg" [alt]="nemad.alt"
                class="ax-h-full ax-w-full ax-object-fill ax-object-center" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <hr class="ax-my-6" />

    <div class="ax-flex ax-flex-col ax-justify-between ax-gap-4 sm:ax-flex-row">
      <p class="ax-font-bold">{{ 'footer.socialMediaTitle' | translate : { params: { siteName: settingData.brandName } }
        | async }}</p>
      <div class="ax-flex ax-gap-4 ax-text-xl ax-text-neutral-400">
        <a [href]="socialMedia.accountAddress" *ngFor="let socialMedia of socialMediaList">
          <ng-container *ngIf="socialMedia.icon; else elseSvgIconTemplate">
            <ax-icon [class]="socialMedia.icon"></ax-icon>
          </ng-container>
          <ng-template #elseSvgIconTemplate>
            <svg role="img" fill="#a3a3a3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
              class="ax-w-ax-h-5 ax-h-5">
              <title>Aparat</title>
              <path
                d="M12.0014 1.5938C2.7317 1.5906-1.9119 12.7965 4.641 19.3515c2.975 2.976 7.4496 3.8669 11.3374 2.257 3.8877-1.61 6.4228-5.4036 6.4228-9.6116 0-5.7441-4.6555-10.4012-10.3997-10.4031zM6.11 6.783c.5011-2.5982 3.8927-3.2936 5.376-1.1028 1.4834 2.1907-.4216 5.0816-3.02 4.5822-1.6118-.3098-2.6668-1.868-2.356-3.4794zm4.322 8.9882c-.5045 2.5971-3.8965 3.288-5.377 1.0959-1.4807-2.1922.427-5.0807 3.0247-4.5789 1.612.3114 2.6655 1.8714 2.3524 3.483zm1.2605-2.405c-1.1528-.2231-1.4625-1.7273-.4917-2.3877.9708-.6604 2.256.18 2.0401 1.3343-.1347.7198-.8294 1.1924-1.5484 1.0533zm6.197 3.8375c-.501 2.5981-3.8927 3.2935-5.376 1.1028-1.4834-2.1908.4217-5.0817 3.0201-4.5822 1.6117.3097 2.6667 1.8679 2.356 3.4794zm-1.9662-5.5018c-2.5981-.501-3.2935-3.8962-1.1027-5.3795 2.1907-1.4834 5.0816.4216 4.5822 3.02-.3082 1.6132-1.8668 2.6701-3.4795 2.3595zm-2.3348 11.5618l2.2646.611c1.9827.5263 4.0167-.6542 4.5433-2.6368l.639-2.4016a11.3828 11.3828 0 0 1-7.4469 4.4274zM21.232 3.5985l-2.363-.6284a11.3757 11.3757 0 0 1 4.3538 7.619l.6495-2.4578c.5194-1.9804-.6615-4.0076-2.6403-4.5328zM.6713 13.8086l-.5407 2.04c-.5263 1.9826.6542 4.0166 2.6368 4.5432l2.1066.5618a11.3792 11.3792 0 0 1-4.2027-7.145zM10.3583.702L8.1498.1261C6.166-.4024 4.1296.7785 3.603 2.763l-.5512 2.082A11.3757 11.3757 0 0 1 10.3583.702Z" />
            </svg>
          </ng-template>
        </a>
      </div>
    </div>

    <hr class="ax-my-6" />
    <!-- حقوق کپی رایت -->
    <div
      class="ax-flex ax-flex-col ax-justify-between ax-gap-4 ax-text-center ax-text-xs ax-text-neutral-400 sm:ax-flex-row sm:ax-text-start">
      <p>
        {{ 'footer.copyRight' | translate : { params: { siteName: settingData.brandName} } | async }}
      </p>
      <p>
        <!-- نسخه -->
        {{ 'footer.version' | translate | async }} {{ version }}
      </p>
    </div>
  </section>
</footer>